var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M265.171,125.577l-80-80c-4.881-4.881-12.797-4.881-17.678,0c-4.882,4.882-4.882,12.796,0,17.678l58.661,58.661H12.5   c-6.903,0-12.5,5.597-12.5,12.5c0,6.902,5.597,12.5,12.5,12.5h213.654l-58.659,58.661c-4.882,4.882-4.882,12.796,0,17.678   c2.44,2.439,5.64,3.661,8.839,3.661s6.398-1.222,8.839-3.661l79.998-80C270.053,138.373,270.053,130.459,265.171,125.577z","data-original":"#000000","className":"active-path","data-old_color":"#ffffff","fill":"#ffffff"}))));
}

RightArrow.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"512px","height":"512px","viewBox":"0 0 268.832 268.832","style":{"enableBackground":"new 0 0 268.832 268.832"},"xmlSpace":"preserve"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
